import { TranslationKeys } from '../types/i18n';

export const se: TranslationKeys = {
  common: {
    loading: "Laddar...",
    error: "Fel",
    success: "Framgång",
    save: "Spara",
    cancel: "Avbryt",
    delete: "Ta bort",
    edit: "Redigera",
    create: "Skapa",
    update: "Uppdatera",
    search: "Sök",
    filter: "Filtrera",
    sort: "Sortera",
    export: "Exportera",
    import: "Importera",
    close: "Stäng",
    back: "Tillbaka",
    status: "Status",
    active: "Aktiv",
    created: "Skapad",
    lastLogin: "Senaste inloggning",
    editUserSettings: "Redigera användarinställningar",
    unknownError: "Okänt fel",
    next: "Nästa",
    previous: "Föregående",
    submit: "Skicka",
    reset: "Återställ",
    confirm: "Bekräfta",
    yes: "Ja",
    no: "Nej",
    new: "Ny",
    of: "av",
    information: "Information",
  },
  
  navigation: {
    home: "Hem",
    users: "Användare",
    settings: "Inställningar",
    userSettings: "Användarinställningar",
    profile: "Profil",
    logout: "Logga ut",
    dashboard: "Dashboard",
    administration: "Administration",
    portal: "Portal",
    forms: "Formulär",
    streamWatch: "StreamWatch",
    txAdmin: "TxAdmin",
    playerReports: "Spelarrapporter",
    documentation: "Dokumentation",
    discordApplications: "Discord Ansökningar",
    dualFtpManager: "Dubbel FTP-hanterare",
  },

  documentation: {
    title: 'Dokumentation',
    description: 'Skapa, hantera och organisera dokumentation för NBRP AEGIS',
    createNew: 'Ny dokumentation',
    uploadFiles: 'Ladda upp filer',
    upload: 'Ladda upp',
    backToDocuments: 'Tillbaka till dokument',
    edit: 'Redigera',
    preview: 'Förhandsgranska',
    saving: 'Sparar...',
    saveDocument: 'Spara dokument',
    titleRequired: 'Titel *',
    titlePlaceholder: 'Ange en beskrivande titel...',
    category: 'Kategori',
    categoryRequired: 'Kategori *',
    selectCategory: 'Välj kategori',
    tags: 'Taggar',
    tagsRequired: 'Taggar *',
    tagsPlaceholder: 'tagg1, tagg2, tagg3',
    summary: 'Sammanfattning',
    summaryRequired: 'Sammanfattning *',
    summaryPlaceholder: 'En kort beskrivning av dokumentet...',
    content: 'Innehåll',
    contentPlaceholder: 'Skriv innehållet i dokumentet...',
    loadingContent: 'Laddar innehåll...',
    noContentAvailable: 'Inget innehåll tillgängligt',
    searchPlaceholder: 'Sök dokument...',
    allCategories: 'Alla kategorier',
    allStatuses: 'Alla statusar',
    published: 'Publicerad',
    draft: 'Utkast',
    archived: 'Arkiverad',
    documentsFound: 'dokument hittade',
    noDocuments: 'Inga dokument',
    noDocumentsFiltered: 'Inga dokument matchade dina sökkriterier.',
    getStarted: 'Kom igång genom att skapa ditt första dokument.',
    createDocument: 'Skapa dokument',
    readMore: 'Läs mer →',
    viewDocument: 'Visa dokument',
    editDocument: 'Redigera dokument',
    deleteDocument: 'Ta bort dokument',
    deleteConfirm: 'Är du säker på att du vill ta bort detta dokument?',
    uploadFile: 'Ladda upp en fil',
    dragDrop: 'or drag and drop',
    fileTypes: 'PDF, DOC, DOCX, TXT, MD, ODT, RTF up to 60MB',
    cancel: 'Cancel',
    uploading: 'Laddar upp...',
    uploadDocument: 'Upload Document',
    loadingError: 'Fel vid laddning av dokumentinnehåll.',
    saveError: 'Fel',
    saveErrorGeneric: 'Ett fel inträffade när dokumentet sparades',
    uploadError: 'Fel',
    uploadErrorGeneric: 'Ett fel inträffade när filen laddades upp',
    fileTooLarge: 'File is too large. Maximum size is 60MB.',
    fileTypeNotSupported: 'File type not supported. Allowed formats: PDF, DOC, DOCX, TXT, MD, ODT, RTF',
    supportedFormats: 'PDF, DOC, DOCX, TXT, MD, ODT, RTF up to 60MB',
    download: 'Download',
    uploadTitle: 'Upload Document',
    uploadDescription: 'Upload files and add metadata for documentation',
    createDescription: 'Create new documentation for NBRP AEGIS system',
    editDescription: 'Update existing documentation',
    openInNewTab: 'Open in new tab',
    previewWillShow: 'Förhandsvisning visas här när innehåll är tillgängligt',
    visibleToRoles: 'Visible to roles',
    veriagent: 'Veriagent',
    moderator: 'Moderator',
    developers: 'Developers',
    admin: 'Admin',
    superAdmin: 'Super Admin',
    standard: 'Standard',
    selectFile: 'Select file',
    categories: {
      userGuides: 'User Guides',
      apiDocumentation: 'API Documentation',
      systemDocumentation: 'System Documentation',
      guidelines: 'Guidelines',
      procedures: 'Procedures',
      technicalDocumentation: 'Technical Documentation',
      faq: 'FAQ',
      training: 'Training',
      meetingMinutes: 'Mötesprotokoll',
    },
  },
  
  auth: {
    login: "Logga in",
    register: "Registrera",
    logout: "Logga ut",
    email: "E-post",
    password: "Lösenord",
    confirmPassword: "Bekräfta lösenord",
    forgotPassword: "Glömt lösenord?",
    resetPassword: "Återställ lösenord",
    welcomeBack: "Välkommen tillbaka",
    createAccount: "Skapa konto",
    alreadyHaveAccount: "Har du redan ett konto?",
    dontHaveAccount: "Har du inget konto?",
    adminLogin: "Admin-inloggning",
    adminLoginDescription: "Få tillgång till administrationspanelen",
    twoFactorVerification: "Tvåfaktorsautentisering",
    setupTwoFactor: "Konfigurera tvåfaktorsautentisering",
    setupTwoFactorDescription: "Skanna QR-koden med din autentiseringsapp",
    signIn: "Logga in",
    signingIn: "Loggar in...",
    verificationCode: "Verifieringskod",
    verify: "Verifiera",
    verifying: "Verifierar...",
    scanQRCode: "Skanna denna QR-kod med din autentiseringsapp",
    backupCodes: "Reservkoder",
    backupCodesDescription: "Spara dessa reservkoder på en säker plats. Du kan använda dem för att komma åt ditt konto om du förlorar din autentiseringsenhet.",
    firstName: "Förnamn",
    lastName: "Efternamn",
    enterCodeFromApp: "Ange koden från din autentiseringsapp",
    completeSetup: "Slutför konfiguration",
    completingSetup: "Slutför konfiguration...",
    enterVerificationCode: "Ange den 6-siffriga koden från din autentiseringsapp",
    changePassword: "Ändra lösenord",
    passwordChangeDescription: "Du måste ändra ditt tillfälliga lösenord innan du kan fortsätta",
    currentPassword: "Nuvarande lösenord",
    newPassword: "Nytt lösenord",
    confirmNewPassword: "Bekräfta nytt lösenord",
    changingPassword: "Ändrar lösenord...",
    passwordChangeSuccess: "Lösenordet har ändrats framgångsrikt. Vänligen logga in med ditt nya lösenord.",
    cfxLogin: "Logga in med CFX.re",
    cfxLoginInfo: "CFX.re Autentisering",
    cfxLoginDescription: "Du kommer att omdirigeras till CFX.re för att autentisera med ditt FiveM-konto.",
    continueWithCFX: "Fortsätt med CFX.re",
    cfxLoginFooter: "Säker autentisering som drivs av FiveM/CFX.re",
    errorOAuthDenied: "Autentisering avbröts",
    errorMissingCode: "Autentisering misslyckades - saknar auktoriseringskod",
    errorAuthFailed: "Autentisering misslyckades - försök igen",
    errorGeneral: "Ett fel uppstod under autentisering",
  },
  
  theme: {
    light: "Ljus",
    dark: "Mörk",
    system: "System",
    toggleTheme: "Växla tema",
  },
  
  language: {
    english: "Engelska",
    norwegian: "Norska",
    swedish: "Svenska",
    changeLanguage: "Ändra språk",
  },

  admin: {
    panel: "Administrationspanel",
    overview: "Dashboard-översikt",
    management: "Hantering",
    addNew: "Lägg till ny",
    recentActivity: "Senaste aktivitet",
    quickActions: "Snabbåtgärder",
    activeUsers: "Aktiva användare",
    monthlySales: "Månatlig försäljning",
    pendingOrders: "Väntande beställningar",
    reviewNeeded: "Granskning krävs",
    thisMonth: "Denna månad",
    thisWeek: "Denna vecka",
    lastMonth: "Förra månaden",
    userRegistration: "Användarregistrering",
    paymentReceived: "Betalning mottagen",
    generateReport: "Generera rapport",
    uploadFiles: "Ladda upp filer",
    fileUploads: "Filuppladdningar",
    orders: "Orders",
    analytics: "Analytik",
    reports: "Reports",
    orderManagement: "Orderhantering",
    recentOrders: "Senaste beställningar",
    salesOverview: "Försäljningsöversikt",
    downloadStatistics: "Nedladdningsstatistik",
    completed: "Slutförd",
    processing: "Processing",
    processed: "Bearbetad",
    view: "View",
    download: "Download",
    fileUploadManager: "Filuppladdningshanterare",
    uploadNewFiles: "Ladda upp nya filer",
    scriptFiles: "Skriptfiler",
    executableFiles: "Körbara filer",
    uploadScriptFiles: "Ladda upp skriptfiler",
    uploadExecutables: "Ladda upp körbara filer",
    dragAndDropScripts: "Drag and drop script files here",
    dragAndDropExecutables: "Drag and drop executable files here",
    selectFiles: "Välj filer",
    recentUploads: "Senaste uppladdningar",
    uploadedAgo: "Uppladdad",
    firstName: "Förnamn",
    lastName: "Efternamn",
    role: "Role",
    status: "Status",
    user: "User",
    admin: "Administrator",
    moderator: "Moderator",
    developers: "Developers",
    active: "Active",
    inactive: "Inactive",
    suspended: "Avstängd",
    registered: "Registrerad",
    hoursAgo: "timmar sedan",
    dayAgo: "dag sedan",
    salesChartsWillBeImplemented: "Försäljningsdiagram kommer att implementeras",
    downloadAnalyticsWillBeShown: "Nedladdningsanalytik kommer att visas",
    versions: "version",
    update: "uppdatering",
    version: "version",
    versions_plural: "versions",
    available: "tillgänglig",
    fileInformation: "Filinformation",
    name: "Namn",
    size: "Size",
    type: "Typ",
    unknown: "Okänd",
    noSales: "Inga försäljningar",
    noOrders: "Inga beställningar",
    noRecentActivity: "Ingen nylig aktivitet",
    activityWillAppearHere: "Aktivitet kommer att visas här när åtgärder utförs",
    noFilesUploaded: "Inga filer uppladdade än",
    useUploadAreasAbove: "Använd uppladdningsområdena ovan för att ladda upp filer",
    noOrdersYet: "Inga beställningar än",
    ordersWillAppearHere: "Beställningar kommer att visas här när kunder gör inköp",
    playerReports: "Spelarrapporter",
    open: "Open",
    resolved: "Löst",
    noReports: "Inga rapporter",
    highPriorityReports: "Högprioriterade rapporter",
    critical: "Critical",
    high: "High",
    allUnderControl: "Allt under kontroll",
    totalReports: "Totala rapporter",
    pendingReviews: "Väntande granskningar",
    openReports: "Öppna rapporter",
    resolvedReports: "Lösta rapporter",
    needAttention: "Behöver uppmärksamhet",
    awaitingReview: "Väntar på granskning",
    created: "Skapad",
    lastLogin: "Senaste inloggning",
    gdprCompliance: "GDPR-efterlevnad",
    gdprConsentText: "GDPR-samtycketext",
    gdprConsentDate: "GDPR-samtyckesdatum",
    sendLoginCredentials: "Skicka inloggningsuppgifter",
    userPermissions: "Användarbehörigheter",
    portalAccess: "Portalåtkomst",
    adminAccess: "Administratörsåtkomst",
    canAccessUserPortal: "Kan komma åt användarportalen",
    canAccessAdminPanel: "Kan komma åt administrationspanelen",
    canManageUsers: "Kan hantera användare",
    superAdmin: "Superadministratör",
    mainAdmin: "Huvudadministratör",
    onlyMainAdmins: "Only main administrators can change user permissions",
    permissionsUpdated: "Användarbehörigheter uppdaterade",
    disable2FAConfirm: "Are you sure you want to disable 2FA for {name}?\n\nThis will:\n- Remove their 2FA protection\n- Force them to set up 2FA again on next login\n- Reduce account security\n\nType \"DISABLE\" to confirm:",
    disable2FA: "Inaktivera 2FA",
    disable2FATooltip: "Inaktivera 2FA för denna användare (endast superadmin)",
    disable2FASuccess: "2FA has been disabled for {name}. They must set it up again on next login.",
    disable2FAError: "Error disabling 2FA for user",
    autoGeneratedPassword: "Automatiskt genererat lösenord",
    autoPasswordInfo: "A secure temporary password will be automatically generated for this user. They must change it on first login before setting up 2FA.",
    temporaryPassword: "Tillfälligt lösenord",
    copyPassword: "Copy",
    copyPasswordSuccess: "Password copied to clipboard!",
    copyPasswordError: "Failed to copy password to clipboard",
    userCreatedSuccess: "User created!",
    savePasswordInstructions: "Please copy the temporary password below and provide it to the user. They must change it on first login.",
    passwordSecurityWarning: "⚠️ Save this password securely - it cannot be retrieved once this dialog is closed.",
    copyPasswordFeedback: "Password copied!",
    resetPassword: "Återställ lösenord",
    resetPasswordTooltip: "Generera nytt tillfälligt lösenord för denna användare",
    resetPasswordConfirm: "Are you sure you want to reset the password for {name}?\n\nThis will:\n- Generate a new temporary password\n- Force them to change password on next login\n- Disable their current access until they log in\n\nType \"RESET\" to confirm:",
    resetPasswordSuccess: "Password has been reset for {name}. They must use the new temporary password and change it on next login.",
    resetPasswordError: "Error resetting password for user",
    newTemporaryPassword: "Nytt tillfälligt lösenord",
    passwordResetNotice: "Lösenordsåterställning",
    passwordResetInstructions: "Please provide this temporary password to the user. They must change it immediately upon login.",
    requiresPasswordChange: "Kräver lösenordsändring",
    globalTranslationsTitle: "Globala översättningar",
    globalSelectApplication: "Välj applikation",
    globalSearchTranslations: "Search translations...",
    globalKey: "Key",
    globalEnglish: "Engelska",
    globalNorwegian: "Norska",
    globalActions: "Åtgärder",
    globalNoTranslationsFound: "Inga översättningar hittades",
    globalAdminApp: "Admin",
    globalPortalApp: "Portal",
    systemLogs: "Systemloggar",
    superAdminOnly: "Endast superadmin",
    allCategories: "Alla kategorier",
    userManagement: "Användarhantering",
    authentication: "Autentisering",
    twoFactorManagement: "2FA-hantering",
    systemSettings: "Systeminställningar",
    security: "Säkerhet",
    apiAccess: "API-åtkomst",
    today: "Idag",
    yesterday: "Igår",
    allTime: "All tid",
    searchLogs: "Sök loggar...",
    showingResults: "Visar",
    logEntries: "loggposter",
    activityLog: "Aktivitetslogg",
    loadingLogs: "Laddar loggar...",
    noLogsFound: "Inga loggar hittades",
    noLogsYet: "Inga loggar än",
    tryDifferentSearch: "Prova en annan sökterm",
    logsWillAppear: "Aktivitetsloggar kommer att visas här",
    logs: "Logs",
    userInformation: "User Information",
    basicInformation: "Grundläggande information",
    fullName: "Full name",
    emailAddress: "Email address",
    securityAndAccess: "Säkerhet och åtkomst",
    twoFactorAuth: "Two-Factor Authentication (2FA)",
    gdprConsent: "GDPR Consent",
    given: "Given",
    missing: "Missing",
    twoFactorEnabled: "User has enabled 2FA and has extra security on their account.",
    twoFactorDisabled: "User has not set up 2FA yet. They will be prompted to set it up on next login.",
    twoFactorEnabledDesc: "User has enabled 2FA and has extra security on their account.",
    twoFactorDisabledDesc: "User has not set up 2FA yet. They will be prompted to set it up on next login.",
    enabled: "Aktiverad",
    notEnabled: "Not enabled",
    twoFactorActivated: "🔒 Enabled",
    twoFactorNotActivated: "⚠️ Not enabled",
    disableTwoFactor: "Disable 2FA",
    gdprConsentGiven: "User has given GDPR consent",
    gdprConsentMissing: "User has not given GDPR consent yet.",
    consentGiven: "✓ Consent given",
    consentMissing: "⚠️ Missing consent",
    administratorAccess: "Administratörsåtkomst",
    userHasAdminAccess: "User has access to the admin panel with the following permissions:",
    deleteUserTooltip: "Permanently delete this user (GDPR compliant)",
    twoFactorAdministration: "2FA Administration",
    twoFactorAdminInfo: "• Super administrators can disable 2FA for all users except other super administrators\n• Administrators cannot disable their own 2FA\n• When 2FA is disabled, the user must set it up again on next login\n• This is useful when users lose their phone or authenticator app",
    searchUsers: "Search users (name, email, role)...",
    usersShowing: "users",
    allUsers: "All users",
    clickForUserInfo: "Click to view user information and manage 2FA",
    noUsersFound: "No users found",
    tryDifferentSearchTerm: "Prova en annan sökterm",
    noUsersMatchSearch: "No users match your search",
    basicTab: "Grundläggande",
    securityTab: "Security",
    permissionsTab: "Permissions",
    activityTab: "Activity",
    gdprInformation: "GDPR Information",
    securityAndAuthentication: "Security and Authentication",
    passwordSecurity: "Password security",
    lastPasswordChange: "Last password change",
    secured: "Säkrad",
    permissionsAndRights: "Permissions and Rights",
    productViewing: "Product viewing",
    successfulLogin: "Successful login",
    twoFactorActivatedAction: "2FA activated",
    selfAdministered: "Self-administered",
    accountCreated: "Account created",
    byAdministrator: "By administrator",
    completeActivityLog: "Complete activity log is available in system logs",
    unauthorizedAction: "You are not authorized to disable 2FA for this user.",
    confirmDeleteFile: "Are you sure you want to delete this file?",
    selectFiveMFiles: "Click to select FiveM script files (.zip, .rar, .7z)",
    selectExecutableFiles: "Click to select executable files (.exe, .msi, .zip)",
    usersWillAppearHere: "Users will appear here when they register",
    editUserSettings: "Redigera användarinställningar",
    deleteUser: "Ta bort användare",
    deleteUserPermanently: "Permanently delete user (GDPR compliant)",
    deleteUserConfirmMessage: "GDPR Notice: Are you sure you want to permanently delete {name}'s account?\n\nThis will:\n- Remove all personal data\n- Cannot be undone\n- User will be notified via email\n\nType \"DELETE\" to confirm:",
    deleteUserSuccess: "User {name} has been deleted in compliance with GDPR. Audit log created.",
    deleteUserError: "Error deleting user: {error}",
    confirmDeletion: "DELETE",
    authenticating: "Authenticating...",
    loadingAdminPanel: "Laddar administrationspanel...",
    noActionsAvailable: "No actions available for your user role",
  },

  settings: {
    title: "Inställningar",
    description: "Hantera kontoinställningar och säkerhetspreferenser",
    accountInformation: "Kontoinformation",
    email: "E-post",
    name: "Namn",
    role: "Roll",
    twoFactorStatus: "2FA-status",
    enabled: "Aktiverad",
    disabled: "Inaktiverad",
    changePassword: "Ändra lösenord",
    currentPassword: "Nuvarande lösenord",
    newPassword: "Nytt lösenord",
    confirmNewPassword: "Bekräfta nytt lösenord",
    passwordRequirements: "Minst 16 tecken, max 60. Måste innehålla versaler, gemener, siffror och specialtecken",
    changingPassword: "Ändrar lösenord...",
    passwordsDoNotMatch: "Lösenorden matchar inte",
    passwordTooShort: "Lösenordet måste vara minst 16 tecken långt",
    passwordTooLong: "Lösenordet kan inte vara mer än 60 tecken långt",
    passwordNeedsUppercase: "Lösenordet måste innehålla minst en versal",
    passwordNeedsLowercase: "Lösenordet måste innehålla minst en gemen",
    passwordNeedsNumber: "Lösenordet måste innehålla minst en siffra",
    passwordNeedsSpecial: "Lösenordet måste innehålla minst ett specialtecken",
    passwordChangeSuccess: "Lösenordet har ändrats framgångsrikt",
    passwordChangeError: "Fel vid ändring av lösenord",
    twoFactorAuthentication: "Tvåfaktorsautentisering",
    twoFactorEnabledDescription: "Tvåfaktorsautentisering är aktiverad för ditt konto.",
    twoFactorDisabledDescription: "Aktivera tvåfaktorsautentisering för att lägga till ett extra säkerhetslager till ditt konto.",
    warning: "Varning",
    disable2FAWarning: "Om du inaktiverar 2FA eller förlorar åtkomst till din autentiseringsapp måste du kontakta en superadmin för att återställa dina 2FA-inställningar.",
    disable2FAConfirm: "Är du säker på att du vill inaktivera 2FA? Detta kommer att minska din kontosäkerhet.",
    disable2FA: "Inaktivera 2FA",
    enable2FA: "Aktivera 2FA",
    regenerateBackupCodes: "Regenerera reservkoder",
    disable2FASuccess: "2FA har inaktiverats. Du måste konfigurera det igen vid nästa inloggning.",
    disable2FAError: "Fel vid inaktivering av 2FA",
    securityInfo: "Säkerhetsinformation",
    twoFactorRequired: "Tvåfaktorsautentisering krävs för alla adminkonton och kan inte inaktiveras av användare. Om du förlorar åtkomst till din autentiseringsapp, kontakta en superadmin för hjälp.",
    securelyConfigured: "Säkert konfigurerad",
    pendingSetup: "Väntar på konfiguration vid nästa inloggning",
    pending: "Väntande",
    
    // TxAdmin Configuration
    txAdminConfiguration: "TxAdmin-konfiguration",
    changeTxAdminPassword: "Ändra TxAdmin-lösenord",
    txAdminAccount: "TxAdmin-konto",
    txAdminPasswordManagement: "TxAdmin Password Management",
    txAdminPasswordDescription: "Change your TxAdmin password here. This will update your password in the TxAdmin system and sync it with your AEGIS account.",
    txAdminUsername: "TxAdmin Username",
    currentTxAdminPassword: "Current TxAdmin Password",
    newTxAdminPassword: "New TxAdmin Password",
    enterTxAdminUsername: "Enter your TxAdmin username",
    enterCurrentTxAdminPassword: "Enter your current TxAdmin password",
    enterNewPassword: "Enter your new password (minimum 8 characters)",
    passwordRequirementsTxAdmin: "Password Requirements:",
    passwordReq1: "Minimum 8 characters, maximum 60 characters",
    passwordReq2: "Use a combination of letters, numbers, and special characters",
    passwordReq3: "Choose a unique password you haven't used elsewhere",
    passwordReq4: "Your new password will be used for TxAdmin panel access",
    passwordReqMinMax: "Minimum 8 characters, maximum 60 characters",
    passwordReqCombination: "Use a combination of letters, numbers, and special characters",
    passwordReqUnique: "Choose a unique password you haven't used elsewhere",
    passwordReqTxAdminAccess: "Your new password will be used for TxAdmin panel access",
    changeTxAdminPasswordBtn: "Change TxAdmin Password",
    changingTxAdminPassword: "Changing TxAdmin password...",
    usernameRequired: "Username is required",
    newPasswordsDoNotMatch: "New passwords do not match",
    passwordMinLength: "Password must be at least 8 characters long",
    passwordMaxLength: "Password must be no more than 60 characters long",
    txAdminPasswordChangeSuccess: "TxAdmin password changed successfully! You can now use your new password to access TxAdmin.",
    txAdminPasswordChangeError: "Failed to change TxAdmin password",
    txAdminTempPasswordNote: "This is a temporary password. You should change it immediately after first login.",
    
    // TxAdmin ModernTxAdmin Component
    sendAnnouncement: "Send Announcement",
    sendAnnouncementToAllPlayers: "Send an announcement to all online players",
    announcementPlaceholder: "Enter your announcement message...",
    announcementTextRequired: "Please enter an announcement message",
    sendingAnnouncement: "Sending announcement...",
    announcementSent: "Announcement sent successfully!",
    announcementFailed: "Failed to send announcement",
    
    // TxAdmin Panel UI / Status (migrated under settings)
    processing: "Processing...",
    overview: "Overview",
    players: "Players",
    resources: "Resources",
    console: "Console",
    logs: "Logs",
    playerHistory: "Player History",
    activeResources: "Active Resources",
    playersOnline: "Players Online",
    serverPerformance: "Serverprestanda",
    serverUptime: "Server Uptime",
    capacity: "Capacity",
    runningSmoothly: "Running smooth",
    zeroTickWarning: "0ms tick",
    txAdminSetupRequired: "TxAdmin Setup Required",
    configureCredentials: "Configure your TxAdmin credentials in User Settings to access the panel",
    credentialsRequired: "TxAdmin Credentials Required",
    needCredentialsDescription: "You need to configure your individual TxAdmin credentials to access the panel.",
    goToUserSettings: "Go to User Settings → TxAdmin to configure your credentials.",
    checkAgain: "Check Again",
    connected: "Ansluten",
    connecting: "Connecting",
    connectedSuccessfully: "Successfully connected to TxAdmin panel",
    attemptingConnection: "Attempting to establish connection to TxAdmin server",
    retry: "Retry",
    rateLimited: "TxAdmin Rate Limited",
    rateLimitDescription: "Showing cached data where available. New requests will be limited.",
    refreshData: "Refresh Data",
    loadingResources: "Loading resources...",
    noResources: "No resources loaded",
    resourceName: "Resource Name",
    actions: "Actions",
    start: "Starta",
    stop: "Stoppa",
    restart: "Starta om",
    started: "Startad",
    stopped: "Stoppad",
    starting: "Startar",
    stopping: "Stoppar",
    restarting: "Startar om",
    online: "Online",
    offline: "Offline",
    searchPlayers: "Sök spelare...",
    searchResults: "Sökresultat",
    noPlayersFound: "Inga spelare hittades som matchar din sökning.",
    playerDetails: "Spelardetaljer",
    ping: "Ping",
    uptime: "Drifttid",
    license: "Licens",
    identifiers: "Identifierare",
    warn: "Varna",
    kick: "Kicka",
    ban: "Banna",
    message: "Meddelande",
    directMessage: "Direktmeddelande",
    selectAction: "Välj åtgärd",
    enterReason: "Ange anledning...",
    reasonRequired: "Vänligen ange en anledning",
    executeAction: "Utför åtgärd",
    executingAction: "Utför åtgärd...",
    actionCompleted: "Åtgärd slutförd framgångsrikt",
    actionFailed: "Åtgärd misslyckades",
    sendCommand: "Skicka kommando",
    enterCommand: "Ange kommando...",
    sendingCommand: "Skickar kommando...",
    commandSent: "Kommando skickat framgångsrikt",
    commandFailed: "Misslyckades att skicka kommando",
    serverConsole: "Serverkonsol",
    serverLogs: "Serverloggar",
    loadingLogs: "Laddar loggar...",
    noLogs: "Inga loggar tillgängliga",
    timestamp: "Tidsstämpel",
    level: "Nivå",
    logMessage: "Meddelande",
    searchDatabase: "Sök databas",
    searchByNameOrLicense: "Sök efter namn eller licens...",
    searchingDatabase: "Söker i databas...",
    playerHistoryDetails: "Spelarhistorikdetaljer",
    filterPlayers: "Filtrera spelare",
    sortPlayers: "Sortera spelare",
    allPlayers: "Alla spelare",
    onlinePlayers: "Spelare online",
    offlinePlayers: "Spelare offline",
    mostRecent: "Senaste",
    oldest: "Äldsta",
    alphabetical: "Alfabetisk",
    mostConnections: "Flest anslutningar",
    lastSeen: "Senast sedd",
    totalConnections: "Totala anslutningar",
    firstSeen: "Första gången sedd",
    loadingHistory: "Laddar historik...",
    noHistoryFound: "Ingen spelarhistorik hittades",
    viewDetails: "Visa detaljer",
    closeDetails: "Stäng detaljer",
    reportPlayer: "Rapportera spelare",
    
    // TxAdmin User Configuration
    txAdminConfigDescription: "Konfigurera dina individuella TxAdmin-inloggningsuppgifter för att få tillgång till serverhanteringsfunktioner. Dessa är separata från ditt NBRP AEGIS-konto.",
    tempPasswordNotice: "💡 Om du fick ett tillfälligt lösenord från en admin kan du ändra det i sektionen \"Ändra TxAdmin-lösenord\" nedan.",
    configurationStatus: "Konfigurationsstatus",
    configuredForUsername: "Konfigurerad för användarnamn: {username}",
    notConfigured: "Inte konfigurerad - TxAdmin-åtkomst otillgänglig",
    configured: "Konfigurerad",
    notConfiguredStatus: "Inte konfigurerad",
    setUpTxAdminCredentials: "Konfigurera TxAdmin-inloggningsuppgifter",
    updateCredentials: "Uppdatera inloggningsuppgifter",
    remove: "Ta bort",
    txAdminPassword: "TxAdmin-lösenord",
    enterTxAdminPassword: "Ange ditt TxAdmin-lösenord",
    securityNotes: "Säkerhetsanteckningar:",
    securityNote1: "Dina inloggningsuppgifter lagras säkert och krypterat",
    securityNote2: "Endast du kan komma åt ditt individuella TxAdmin-konto",
    securityNote3: "Dessa inloggningsuppgifter används endast för TxAdmin-autentisering",
    saveTxAdminCredentials: "Spara TxAdmin-inloggningsuppgifter",
    savingCredentials: "Sparar inloggningsuppgifter...",
    txAdminCredentialsSaved: "TxAdmin-inloggningsuppgifter sparade framgångsrikt!",
    txAdminCredentialsError: "Misslyckades att spara TxAdmin-inloggningsuppgifter",
    removeTxAdminConfirm: "Är du säker på att du vill ta bort dina TxAdmin-inloggningsuppgifter? Du behöver konfigurera dem igen för att få tillgång till TxAdmin.",
    txAdminCredentialsRemoved: "TxAdmin-inloggningsuppgifter borttagna framgångsrikt",
    
    // Additional TxAdmin translations
    passwordTooShortTxAdmin: "Lösenordet måste vara minst 8 tecken långt",
    passwordTooLongTxAdmin: "Lösenordet får inte vara längre än 60 tecken",
    fillAllRequiredFields: "Vänligen fyll i alla obligatoriska fält",
    failedToSaveTxAdminCredentials: "Misslyckades att spara TxAdmin-inloggningsuppgifter",
    failedToSaveCredentials: "Misslyckades att spara inloggningsuppgifter",
    errorSavingCredentials: "Fel vid sparande av inloggningsuppgifter",
    failedToRemoveTxAdminCredentials: "Misslyckades att ta bort TxAdmin-inloggningsuppgifter",
    errorRemovingCredentials: "Fel vid borttagning av inloggningsuppgifter",
    unknownError: "Okänt fel",
    edit: "Redigera",
    cancel: "Avbryt",
    saving: "Sparar...",
    saveCredentials: "Save Credentials",
    clear: "Clear",
    credentialsSecurelyStored: "Your credentials are stored securely and encrypted",
    onlyYouAccess: "Only you can access your individual TxAdmin account",
    credentialsOnlyForAuth: "These credentials are only used for TxAdmin authentication",
    
    // CFG Editor
    cfgEditor: "CFG Editor",
    serverConfigurationEditor: "Server Configuration Editor",
    saveFile: "Save File",
    saveFileShortcut: "Save File (Ctrl+S)",
    savingFile: "Saving...",
    keyboardShortcuts: "Keyboard Shortcuts:",
    saveFileShortcutDesc: "Save file",
    insertSpaces: "Insert 4 spaces",
    cfgEditorHelpText: "Changes will be backed up automatically before saving. Make sure to test your configuration changes before restarting the server.",
    cfgPlaceholder: "# Server Configuration File\n# Add your server.cfg content here...",
    loadingCfgFile: "Loading server.cfg file...",
    failedToLoadCfg: "Failed to load server.cfg file",
    cfgSavedSuccessfully: "server.cfg file saved successfully",
    failedToSaveCfg: "Failed to save server.cfg file",
    checkTxAdminConnection: "Please check your TxAdmin connection."
  },

  // TxAdmin ModernTxAdmin Component
  txAdmin: {
    // Tab Labels
    overview: "Overview",
    players: "Players",
    resources: "Resources",
    console: "Console",
    logs: "Logs",
    playerHistory: "Player History",
    
    // General UI
    processing: "Processing...",
    connected: "Ansluten",
    connecting: "Connecting",
    retry: "Retry",
    refreshData: "Refresh Data",
    checkAgain: "Check Again",
    serverControls: "Server Controls",
    
    // Status Messages
    connectedSuccessfully: "Successfully connected to TxAdmin panel",
    attemptingConnection: "Attempting to establish connection to TxAdmin server",
    txAdminSetupRequired: "TxAdmin Setup Required",
    configureCredentials: "Configure your TxAdmin credentials in User Settings to access the panel",
    credentialsRequired: "TxAdmin Credentials Required",
    needCredentialsDescription: "Du behöver konfigurera dina individuella TxAdmin-inloggningsuppgifter för att få tillgång till panelen.",
    goToUserSettings: "Gå till Användarinställningar → TxAdmin för att konfigurera dina inloggningsuppgifter.",
    rateLimited: "TxAdmin hastighetsbegränsad",
    rateLimitDescription: "Visar cachad data där tillgängligt. Nya förfrågningar kommer att begränsas.",
    rateLimitedWait: "Hastighetsbegränsad. Vänligen vänta",
    minutes: "minuter innan du försöker igen",
    authenticationFailed: "Autentisering misslyckades",
    tooManyAttempts: "För många inloggningsförsök. Använder mockdata. Vänligen vänta",
    cannotConnect: "Kan inte ansluta till TxAdmin-server. Vänligen kontrollera din konfiguration.",
    failedToConnect: "Misslyckades att ansluta till TxAdmin",
    txAdminRateLimited: "TxAdmin är hastighetsbegränsad",
    notConnected: "Inte ansluten till TxAdmin",
    connectToViewLogs: "Anslut till TxAdmin för att visa serverloggar",
    logsWillAppear: "Realtidsserverloggar kommer att visas här när ansluten",
    connectToViewResources: "Anslut till TxAdmin för att visa serverresurser",
    resourcesWillAppear: "Serverresurser kommer att visas här när ansluten",
    connectToViewPlayers: "Anslut till TxAdmin för att visa spellista",
    playersWillAppear: "Spelare kommer att visas här när de ansluter till servern",
    
    // Overview Section
    activeResources: "Aktiva resurser",
    playersOnline: "Spelare online",
    serverPerformance: "Serverprestanda",
    serverUptime: "Serverdrifttid",
    capacity: "Kapacitet",
    runningSmoothly: "Kör smidigt",
    zeroTickWarning: "0ms tick",
    
    // Resources Section
    loadingResources: "Laddar resurser...",
    noResources: "Inga resurser laddade",
    resourceName: "Resursnamn",
    start: "Starta",
    stop: "Stoppa",
    restart: "Starta om",
    started: "Startad",
    stopped: "Stoppad",
    starting: "Startar",
    stopping: "Stoppar",
    restarting: "Startar om",
    
    // Players Section
    searchPlayers: "Sök spelare...",
    searchResults: "Sökresultat",
    noPlayersFound: "Inga spelare hittades som matchar din sökning.",
    noPlayersOnline: "Inga spelare online",
    playerDetails: "Spelardetaljer",
    ping: "Ping",
    uptime: "Drifttid",
    license: "Licens",
    identifiers: "Identifierare",
    warn: "Warn",
    kick: "Kick",
    ban: "Ban",
    message: "Message",
    directMessage: "Direct Message",
    selectAction: "Select Action",
    enterReason: "Enter reason...",
    reasonRequired: "Please enter a reason",
    executeAction: "Execute Action",
    executingAction: "Executing action...",
    actionCompleted: "Action completed successfully",
    actionFailed: "Action failed",
    reportPlayer: "Report Player",
    
    // Console Section
    sendCommand: "Send Command",
    enterCommand: "Enter command...",
    sendingCommand: "Sending command...",
    commandSent: "Command sent successfully",
    commandFailed: "Failed to send command",
    serverConsole: "Server Console",
    
    // Logs Section
    serverLogs: "Server Logs",
    loadingLogs: "Loading logs...",
    noLogs: "No logs available",
    timestamp: "Timestamp",
    level: "Level",
    logMessage: "Message",
    
    // History Section
    searchDatabase: "Search Database",
    searchByNameOrLicense: "Search by name or license...",
    searchingDatabase: "Searching database...",
    playerHistoryDetails: "Player History Details",
    filterPlayers: "Filter Players",
    sortPlayers: "Sort Players",
    allPlayers: "All Players",
    onlinePlayers: "Online Players",
    offlinePlayers: "Offline Players",
    mostRecent: "Most Recent",
    oldest: "Oldest",
    alphabetical: "Alphabetical",
    mostConnections: "Most Connections",
    lastSeen: "Last Seen",
    totalConnections: "Total Connections",
    firstSeen: "First Seen",
    loadingHistory: "Loading history...",
    noHistoryFound: "No player history found",
    viewDetails: "View Details",
    closeDetails: "Close Details",
    
    // Announcements
    sendAnnouncement: "Send Announcement",
    sendAnnouncementToAllPlayers: "Send an announcement to all online players",
    announcementPlaceholder: "Enter your announcement message...",
    announcementTextRequired: "Please enter an announcement message",
    sendingAnnouncement: "Sending announcement...",
    announcementSent: "Announcement sent successfully!",
    announcementFailed: "Failed to send announcement",
    
    // Common Status
    online: "Online",
    offline: "Offline",
    unknown: "Okänd",
    status: "Status",
    version: "Version",
    startResource: "Start resource",
    stopResource: "Stop resource",
    restartResource: "Restart resource",
    warnPlayer: "Warn player",
    kickPlayer: "Kick player",
    banPlayer: "Ban player",
    sendMessage: "Send message",
    target: "Target",
    reason: "Reason",
    duration: "Duration",
    enterReasonFor: "Enter reason for",
    oneHour: "1 hour",
    sixHours: "6 hours",
    twelveHours: "12 hours",
    oneDay: "1 day",
    threeDays: "3 days",
    oneWeek: "1 week",
    oneMonth: "1 month",
    permanent: "Permanent",
    enterMessageToPlayer: "Enter message to player",
    cancel: "Cancel",
    createNewAdmin: "Skapa ny admin",
    username: "Username",
    enterUsername: "Enter username",
    fivemIdPlaceholder: "Enter FiveM ID (optional)",
    discordIdPlaceholder: "Enter Discord ID (optional)",
    permissions: "Permissions",
    creating: "Creating...",
    createAdmin: "Skapa admin",
    adminCreatedSuccessfully: "Admin created successfully",
    importantInformation: "Important Information",
    passwordOnlyShownOnce: "This password is only shown once. Make sure to copy and store it safely!",
    temporaryPassword: "Temporary password",
    instructionsForNewAdmin: "Instructions for new admin",
    loginInstruction: "Login to txAdmin with this username and password",
    changePasswordFirstLogin: "Change password immediately after first login",
    chooseStrongPassword: "Choose a strong, unique password",
    keepCredentialsPrivate: "Keep login information private and secure",
    copyAll: "Copy all",
    close: "Stäng",
    sendAnnouncementToAll: "Send announcement to all players",
    announcementInfo: "Information about announcements and messages",
    actions: "Actions",
    
    // CFG Editor
    serverConfigurationEditor: "Server Configuration Editor",
    savingFile: "Saving...",
    cfgSavedSuccessfully: "server.cfg file saved successfully",
    failedToLoadCfg: "Failed to load server.cfg file",
    failedToSaveCfg: "Failed to save server.cfg file",
    saveFileShortcut: "Save File (Ctrl+S)",
    saveFileShortcutDesc: "Save file",
    cfgPlaceholder: "# Server Configuration File\n# Add your server.cfg content here...",
    keyboardShortcuts: "Keyboard Shortcuts:",
    insertSpaces: "Insert 4 spaces",
    cfgEditorHelpText: "Changes will be backed up automatically before saving. Make sure to test your configuration changes before restarting the server."
  },

  users: {
    title: "Användarhantering",
    management: "Användarhantering",
    createUser: "Skapa användare",
    editUser: "Redigera användare",
    deleteUser: "Ta bort användare",
    userDetails: "Användardetaljer",
    userList: "Användarlista",
    searchUsers: "Sök användare",
    noUsersFound: "Inga användare hittade",
    userCreated: "Användare skapad",
    userUpdated: "Användare uppdaterad",
    userDeleted: "Användare borttagen",
    confirmDelete: "Bekräfta borttagning",
    deleteConfirmation: "Är du säker på att du vill ta bort denna användare?",
    basicInformation: "Grundläggande information",
    securitySettings: "Säkerhetsinställningar",
    permissions: "Behörigheter",
    fullName: "Fullständigt namn",
    emailAddress: "E-postadress",
    role: "Roll",
    status: "Status",
    active: "Aktiv",
    inactive: "Inaktiv",
    lastLogin: "Senaste inloggning",
    createdAt: "Skapad",
    twoFactorAuth: "Tvåfaktorsautentisering",
    enabled: "Aktiverad",
    disabled: "Inaktiverad",
    gdprConsent: "GDPR-samtycke",
    consentGiven: "Samtycke givet",
    consentMissing: "Samtycke saknas"
  },

  roles: {
    admin: "Administratör",
    moderator: "Moderator",
    user: "Användare",
    veriagent: "Veriagent",
    superAdmin: "Super Administratör",
    developer: "Utvecklare",
    createAdmin: "Administratör",
    createModerator: "Moderator",
    createUser: "Användare",
    createVeriagent: "Veriagent",
    createDeveloper: "Developer"
  },

  forms: {
    title: "Formulär",
    description: "Skapa och hantera Discord-formulär för spelaransökningar",
    createNew: "Skapa nytt formulär",
    createFirst: "Skapa ditt första formulär",
    loading: "Laddar formulär...",
    noFormsTitle: "Inga formulär skapade än",
    noFormsDescription: "Skapa ditt första Discord-formulär för att börja samla in spelaransökningar.",
    submissions: "Inskickningar:",
    fields: "Fält:",
    discordBot: "Discord Bot:",
    created: "Skapad:",
    view: "Visa",
    edit: "Redigera",
    delete: "Ta bort",
    close: "Stäng",
    deleteConfirmation: "Är du säker på att du vill ta bort detta formulär? Alla inskickade ansökningar kommer också att tas bort.",
    discordIntegrationTitle: "Discord Integration Status",
    discordBotConnection: "Discord Bot-anslutning",
    discordIntegrationDescription: "Formulär kommer automatiskt att skickas till Discord när de skickas in",
    configureInSettings: "Konfigurera i Inställningar → Discord Bot-inställningar",
    viewFormModalTitle: "Visa formulärmodal",
    viewFormModalDescription: "Denna modal måste extraheras från page.tsx",
    unknownBot: "Okänd Bot",
    formName: "Formulärnamn",
    formNamePlaceholder: "Ange formulärnamn...",
    formDescription: "Formulärbeskrivning",
    formDescriptionPlaceholder: "Beskrivning av formuläret (valfritt)...",
    welcomeMessage: "Välkomstmeddelande",
    welcomeMessagePlaceholder: "Välkomstmeddelande som visas längst upp i formuläret...",
    selectDiscordBot: "Välj Discord Bot",
    selectBotPlaceholder: "Välj en Discord-bot...",
    formFields: "Formulärfält",
    addField: "Lägg till fält",
    fieldLabel: "Fältetikett",
    fieldType: "Fälttyp",
    fieldRequired: "Obligatorisk",
    fieldOptions: "Fältalternativ",
    fieldOptionsPlaceholder: "Ange alternativ separerade med kommatecken...",
    removeField: "Ta bort fält",
    textInput: "Textinmatning",
    selectDropdown: "Välj rullgardinsmeny",
    radioButtons: "Radioknappar",
    checkboxes: "Kryssrutor",
    textarea: "Textområde",
    discordLanguage: "Discord-språk",
    discordLanguageDescription: "Välj språk för meddelanden som visas på Discord",
    english: "Engelska",
    norwegian: "Norska",
    submitButtonText: "Skicka-knapptext",
    successMessage: "Framgångsmeddelande",
    formPreview: "Formulärförhandsvisning",
    createForm: "Skapa formulär",
    cancel: "Avbryt",
    reset: "Återställ",
    longText: "Lång text",
    number: "Nummer",
    email: "E-post",
    date: "Datum",
    dropdownSelection: "Rullgardinsmenyval",
    multipleChoice: "Flerval",
    checkbox: "Kryssruta",
    discordUsername: "Discord-användarnamn",
    characterName: "Karaktärsnamn",
    enterCharacterName: "Ange ditt karaktärsnamn...",
    botHandleSubmissions: "Denna bot kommer att hantera formulärinskickningar och notifieringar",
    fieldNumber: "Fält #",
    placeholderText: "Platshållartext",
    helperText: "Hjälptext för detta fält...",
    required: "Obligatorisk",
    options: "Alternativ",
    addOption: "Lägg till alternativ",
    option: "Alternativ",
    untitledForm: "Namnlöst formulär",
    selectOption: "Välj ett alternativ",
    checkboxOption: "Markera detta alternativ",
    resetForm: "Återställ formulär"
  },

  discordApplications: {
    title: "Discord Applications",
    description: "Process applications submitted from Discord bots",
    loading: "Loading applications...",
    createNew: "+ Skapa ny applikationstyp",
    createFirst: "Skapa första applikationstypen",
    noApplicationTypes: "Inga applikationstyper skapade",
    noApplicationTypesDescription: "Skapa din första applikationstyp för att ta emot ansökningar från Discord.",
    noAccessDescription: "Du har inte åtkomst att se några applikationstyper ännu.",
    searchPlaceholder: "Search by applicant name or Discord ID...",
    showingResults: "Showing {count} of {total} applications",
    noApplicationsFound: "No applications found for search.",
    noApplicationsYet: "No applications yet.",
    applicationsFromDiscord: "Applications will appear here when users submit via Discord.",
    applicantName: "Applicant Name",
    discordId: "Discord ID",
    submittedAt: "Inskickad",
    status: "Status",
    applicationData: "Application Data",
    reviewedAt: "Granskad",
    pending: "Pending",
    approved: "Godkänd",
    rejected: "Avvisad",
    approve: "✓ Approve",
    reject: "✗ Reject",
    // Create Modal
    createModalTitle: "Skapa ny applikationstyp",
    createModalDescription: "Skapa en ny typ av applikation som kan ta emot data från en Discord-bot",
    typeNameLabel: "Applikationstypnamn",
    typeNamePlaceholder: "e.g. Whitelist Application, Staff Application...",
    selectBotLabel: "Select Discord Bot (whitelist bots only)",
    selectBotPlaceholder: "Choose a whitelist bot...",
    visibilityLabel: "Vem kan se denna applikationstyp?",
    visibilityDescription: "Only selected roles will be able to see and process applications of this type",
    veriagent: "Veriagent",
    moderator: "Moderator",
    developers: "Developers",
    admin: "Admin",
    superAdmin: "Super Admin",
    cancel: "Cancel",
    create: "Skapa",
    // Delete functionality
    deleteType: "Delete application type",
    confirmDeleteType: "To delete the application type",
    typeDeleteToConfirm: "type DELETE to confirm",
    deleteWarning: "This action cannot be undone. If there are existing applications for this type, they must be handled first.",
    // New application indicators
    newToday: "NEW",
    pendingReview: "AWAITING REVIEW",
    awaitingReview: "awaiting review"
  },

  whitelistForms: {
    title: "Whitelist Forms",
    description: "Manage whitelist application forms",
    loading: "Loading forms...",
    noFormsYet: "No forms created yet",
    noFormsYetDescription: "Create your first whitelist form to start receiving applications.",
    createFirst: "Create First Form",
    createNew: "Create New Form",
    searchPlaceholder: "Search forms...",
    formName: "Form Name",
    formType: "Form Type",
    createdAt: "Skapad",
    status: "Status",
    actions: "Actions",
    edit: "Redigera",
    delete: "Ta bort",
    view: "Visa",
    submissions: "Submissions",
    active: "Active",
    inactive: "Inactive",
    draft: "Draft",
    published: "Publicerad",
    confirmDelete: "Are you sure you want to delete this form?",
    deleteWarning: "This action cannot be undone. All form submissions will be lost.",
    noSubmissions: "No submissions yet",
    viewSubmissions: "View Submissions"
  },

  streamWatch: {
    title: "StreamWatch",
    description: "Övervaka streamers på flera plattformar och få Discord-notifikationer",
    loading: "Laddar...",
    loadingStreamers: "Laddar streamers...",
    addStreamer: "Lägg till streamer",
    addFirstStreamer: "Lägg till din första streamer",
    searchPlaceholder: "Sök streamers...",
    // Filters
    allPlatforms: "Alla plattformar",
    allStatus: "All status",
    liveNow: "Sänder nu",
    offline: "Offline",
    activeMonitoring: "Aktiv övervakning",
    inactive: "Inaktiv",
    // Platform names
    platforms: {
      twitch: "Twitch",
      youtube: "YouTube Gaming",
      kick: "Kick"
    },
    // Status badges
    status: {
      inactive: "Inaktiv",
      live: "🔴 Live",
      offline: "Offline"
    },
    // Empty states
    noStreamersYet: "Inga streamers tillagda än",
    noStreamersMatch: "Inga streamers matchar dina filter",
    noStreamersYetDescription: "Lägg till din första streamer för att börja övervaka livestreams",
    noStreamersMatchDescription: "Försök justera dina sök- eller filterkriterier",
    // Streamer info
    playing: "Spelar:",
    viewers: "tittare",
    lastChecked: "Senast kontrollerat:",
    lastLive: "Senast live:",
    discordNotifications: "📢 Discord-notifikationer aktiverade",
    delete: "🗑️ Ta bort",
    // Delete confirmation
    confirmDelete: "Är du säker på att du vill ta bort {name} från övervakning?",
    deleteError: "Misslyckades att ta bort streamer: {error}",
    deleteFailed: "Misslyckades att ta bort streamer. Försök igen.",
    // Modal
    addStreamerModal: {
      title: "Lägg till ny streamer",
      description: "Lägg till en ny streamer för att övervaka livestream-notifikationer",
      usernameLabel: "Streamer-användarnamn",
      usernamePlaceholder: "Ange streamerns användarnamn",
      platformLabel: "Plattform",
      displayNameLabel: "Visningsnamn",
      displayNamePlaceholder: "Valfritt visningsnamn för notifikationer",
      customMessageLabel: "Anpassat notifikationsmeddelande",
      customMessagePlaceholder: "🔴 {displayName} streamar nu på {platform}! Kom och titta: {url}",
      customMessageHelp: "Tillgängliga variabler: {displayName}, {platform}, {title}, {game}, {url}",
      activeMonitoringLabel: "Aktiv övervakning",
      discordNotificationsTitle: "Discord-notifikationer aktiverade",
      discordNotificationsDescription: "Denna streamer kommer att använda \"Streaming\" Discord-boten. Konfigurera bot-inställningar och kanal i Discord Bot-inställningar.",
      selectBot: "Discord-bot (för notifikationer)",
      selectBotPlaceholder: "Välj en Discord-bot...",
      channelLabel: "Discord-kanal-ID (för notifikationer)",
      channelPlaceholder: "Ange Discord-kanal-ID (t.ex. 123456789012345678)",
      streamerHelp: "Ange det exakta användarnamnet som det visas på plattformen (utan @-symbol)",
      cancel: "Avbryt",
      addStreamer: "Lägg till streamer",
      errors: {
        usernameRequired: "Användarnamn krävs",
        platformRequired: "Välj en plattform",
        botRequired: "Välj en Discord-bot",
        channelRequired: "Discord-kanal-ID krävs",
        addFailed: "Misslyckades att lägga till streamer: {error}",
        tryAgain: "Misslyckades att lägga till streamer. Försök igen."
      }
    }
  },

  autoStreamChecker: {
    title: "Streamövervakare",
    automaticChecking: "🤖 Automatisk kontroll var 2:a minut",
    checkNow: "🔄 Kontrollera nu",
    checking: "⏳ Kontrollerar...",
    currentlyLive: "Sänder just nu",
    currentlyOffline: "Offline för tillfället",
    lastChecked: "Senast kontrollerat:"
  },

  discordAnnouncements: {
    title: "Discord-meddelanden",
    description: "Skicka ändringsloggar och viktiga meddelanden till Discord-kanaler",
    tabs: {
      changelog: "Ändringslogg",
      announcements: "Meddelanden", 
      settings: "Inställningar"
    },
    newChangelog: "Ny ändringslogg",
    newAnnouncement: "Nytt meddelande",
    changelogDescription: "Skicka ändringsloggar till spelare via @CHANGELOG",
    announcementDescription: "Skicka viktiga meddelanden till alla via @everyone",
    colorSettings: "Färginställningar",
    colorSettingsDescription: "Välj färger för ändringslogg- och meddelandemeddelanden",
    titleLabel: "Titel",
    titleRequired: "Titel *",
    titleChangelogPlaceholder: "t.ex. Ändringslogg 04.03.2025",
    titleAnnouncementPlaceholder: "t.ex. Viktigt servermeddelande",
    contentLabel: "Innehåll",
    contentRequired: "Innehåll *",
    changelogContentPlaceholder: "[+] Lagt till racingkapacitet\n[+] Lagt till driftkapacitet\n[+] Lagt till tre nya föremål på en plats\n[-] Ändrat material för pistol och pistolammunition\n[&] Ändrat plats och logotyp för Hayes",
    announcementContentPlaceholder: "Viktig information som alla spelare måste se...",
    changelogTip: "Använd [+] för nya funktioner, [-] för ändringar, [&] för reparationer",
    announcementTip: "Skriv viktig information som alla spelare måste se",
    discordBotLabel: "Discord-bot",
    discordBotRequired: "Discord-bot *",
    selectDiscordBot: "Välj Discord-bot",
    sendChangelog: "📤 Skicka ändringslogg",
    sendAnnouncement: "📤 Skicka meddelande", 
    sending: "Skickar...",
    changelogColor: "📝 Ändringsloggfärg",
    announcementColor: "📢 Meddelandefärg",
    discordPreview: "Discord Preview",
    discordPreviewDescription: "This is how the message will appear in Discord",
    colorPreviewDescription: "This is how the colors will appear in Discord",
    changelogPreview: "📝 Changelog Preview",
    announcementPreview: "📢 Announcement Preview",
    changelogExample: "Changelog Example",
    announcementExample: "Announcement Example",
    changelogExampleDescription: "This is how changelog messages will appear",
    announcementExampleDescription: "This is how announcement messages will appear",
    colorsAutoSaved: "Colors are saved automatically",
    colorsAutoSavedDescription: "When you select a new color it will be automatically saved and used in future messages",
    noBotsConfigured: "Inga Discord-botar konfigurerade",
    noBotsConfiguredDescription: "You must create and configure a Discord bot in Settings before you can send messages",
    changelogHelpers: "Changelog Helpers",
    addFeature: "New Feature",
    addChange: "Change",
    addFix: "Fix",
    changelogHelpersDescription: "Click the buttons to add changelog formats automatically",
    teamName: "👥 Team Name",
    teamNameDescription: "This name appears in the footer of all Discord messages",
    teamNamePlaceholder: "Team Nightbox",
    teamNameDefault: "Team Nightbox",
    discordSettings: "Discord Settings",
    discordSettingsDescription: "Customize the appearance of your Discord messages",
    examples: {
      changelogTitle: "Changelog Example",
      announcementTitle: "Announcement Example",
      addedRacing: "Added racing capabilities",
      addedDrifting: "Added drifting capabilities",
      changedMaterials: "Changed materials for pistol",
      fixedLocation: "Fixed location and logo for Hayes",
      announcementDescription: "This is how announcement messages will appear"
    },
    errors: {
      noBotSelected: "No Discord bot selected",
      botNotConnected: "Selected Discord bot is not connected",
      fillTitleContent: "Please fill in title and content",
      channelNotConfigured: "channel ID not configured for this bot. Go to Settings → Discord Bot Settings and add channel ID"
    },
    success: {
      changelogSent: "Changelog sent to Discord!",
      announcementSent: "Announcement sent to Discord!"
    },
    apiErrors: {
      discordError: "Error sending to Discord. Check bot token and channel ID",
      generalError: "Error sending to Discord"
    }
  },

  systemSettings: {
    title: "Inställningar",
    description: "Konfigurera systeminställningar, integrationer och säkerhetsalternativ",
    tabs: {
      txadmin: "TxAdmin-inställningar",
      discord: "Discord Bot-inställningar", 
      webhook: "Webhook-inställningar",
      violations: "Regelöverträdelser",
      todoCategories: "Todo-kategorier",
      translations: "Språkredigerare"
    },
    txadmin: {
      title: "TxAdmin-integrationsinställningar",
      serverUrl: "TxAdmin Server-URL",
      username: "Användarnamn",
      password: "Lösenord",
      testConnection: "Testa anslutning",
      saveSettings: "Spara inställningar",
      connected: "Ansluten framgångsrikt",
      server: "Server:",
      lastSync: "Senaste synkronisering:",
      connectionFailed: "Anslutning misslyckades:",
      saveFailed: "Sparning misslyckades:",
      settingsSaved: "TxAdmin-inställningar sparade framgångsrikt",
      enterCredentials: "Vänligen ange Server-URL, användarnamn och lösenord innan du testar anslutning",
      credentialsRequired: "Server-URL, användarnamn och lösenord krävs"
    },
    discord: {
      title: "Discord Bot-inställningar",
      selectBot: "Välj bot att konfigurera",
      addNewBot: "Lägg till ny bot",
      sendFormMenus: "Skicka formulärmenyer",
      syncAllCommands: "Synkronisera alla kommandon",
      createNewBot: "Skapa ny Discord-bot",
      editBot: "Redigera Discord-bot",
      manageForms: "Hantera formulär för",
      botName: "Bot-namn",
      botNameRequired: "Bot-namn krävs",
      botNamePlaceholder: "t.ex. VIP Whitelist Bot, Staff Applications Bot",
      botNameDescription: "Ge din Discord-bot ett beskrivande namn för att identifiera dess syfte",
      botType: "Bot-typ",
      botTypeRequired: "Bot-typ *",
      clientId: "Discord Client-ID",
      clientIdPlaceholder: "Ditt Discord Application Client-ID",
      clientSecret: "Discord Client Secret", 
      botToken: "Discord Bot-token",
      botTokenPlaceholder: "Din Discord Bot-token",
      guildId: "Discord Guild-ID", 
      guildIdPlaceholder: "Ditt Discord Server-ID",
      whitelistChannelId: "Whitelist-kanal ID",
      whitelistChannelIdPlaceholder: "Kanal-ID för whitelist-ansökningar",
      changelogChannelId: "Ändringslogg-kanal ID",
      changelogChannelIdPlaceholder: "Kanal-ID för ändringsloggmeddelanden",
      changelogChannelDescription: "Standard channel for @CHANGELOG messages",
      announcementChannelId: "Announcement Channel ID",
      announcementChannelIdPlaceholder: "Channel ID for announcement messages", 
      announcementChannelDescription: "Standard channel for @everyone messages",
      changelogRoleId: "Changelog Role ID",
      changelogRoleIdPlaceholder: "Role ID for @CHANGELOG mentions",
      status: "Status",
      active: "Active",
      inactive: "Inactive",
      testConnection: "Test Connection",
      saveSettings: "Save Settings",
      syncCommands: "Sync Commands",
      editSettings: "Edit Settings",
      deleteBot: "Delete Bot",
      connected: "Connected Successfully",
      lastSync: "Last sync:",
      connectionFailed: "Connection failed:",
      saveFailed: "Save failed:",
      settingsSaved: "Discord bot settings saved successfully",
      botCreated: "Discord bot created successfully",
      botUpdated: "Discord bot updated successfully",
      botDeleted: "Discord bot deleted successfully",
      enterCredentials: "Please enter Client ID, Client Secret, and Bot Token before testing connection",
      deleteConfirm: "Are you sure you want to delete this bot? This action cannot be undone.",
      configure: "Configure:",
      botTypes: {
        whitelist: {
          label: "Whitelist Bot",
          description: "Handles form submissions and whitelist applications",
          icon: "📋"
        },
        announcements: {
          label: "Announcements Bot", 
          description: "Posts server updates, changelogs and announcements to Discord channels",
          icon: "📢"
        },
        streaming: {
          label: "Streaming Bot",
          description: "Monitors and announces when streamers go live on Twitch",
          icon: "🤖"
        }
      },
      setup: {
        steps: {
          step1: "Step 1: Create Discord Application",
          step2: "Step 2: Configure Bot Settings",
          step3: "Step 3: Set Permissions",
          step4: "Step 4: Test Connection",
          step5: "Step 5: Deploy Commands"
        },
        connectionStatus: {
          connected: "Bot är ansluten och redo",
          testOnline: "Testar anslutning..."
        },
        applicationTypes: {
          title: "Discord-applikationstyper",
          description: "Välj typ av Discord-applikation att skapa",
          instructions: {
            create: "Skapa en ny Discord-applikation",
            link: "Länka en befintlig applikation",
            naming: "Använd beskrivande namn för dina applikationer",
            warning: "Håll dina bot-tokens säkra"
          }
        }
      },
      messages: {
        createSuccess: "Discord-bot skapad framgångsrikt",
        createError: "Misslyckades att skapa Discord-bot",
        updateSuccess: "Discord-bot uppdaterad framgångsrikt",
        updateError: "Misslyckades att uppdatera Discord-bot",
        deleteSuccess: "Discord-bot borttagen framgångsrikt",
        deleteError: "Misslyckades att ta bort Discord-bot",
        saveSuccess: "Inställningar sparade framgångsrikt",
        saveError: "Misslyckades att spara inställningar"
      }
    },
    webhook: {
      title: "Webhook-inställningar",
      language: "Språk",
      languageDescription: "Välj språk för webhook-notifieringar",
      english: "Engelska", 
      norwegian: "Norska",
      enabled: "Aktiverad",
      disabled: "Inaktiverad",
      testLanguage: "Testa språk",
      saveSettings: "Spara inställningar",
      settingsSaved: "Webhook-inställningar sparade framgångsrikt",
      testSent: "Testmeddelande skickat!"
    },
    translations: {
      title: "Språkredigerare",
      description: "Redigera och hantera översättningar för engelska och norska språk",
      searchPlaceholder: "Sök översättningsnycklar...",
      keyColumn: "Översättningsnyckel",
      englishColumn: "Engelska",
      norwegianColumn: "Norska",
      saveChanges: "Spara ändringar",
      saving: "Sparar översättningar...",
      saved: "Översättningar sparade framgångsrikt!",
      resetChanges: "Återställ ändringar",
      confirmReset: "Are you sure you want to reset all unsaved changes?",
      noChanges: "No changes to save",
      expandAll: "Expand All",
      collapseAll: "Collapse All",
      filterBySection: "Filter by section",
      allSections: "All Sections",
      changesDetected: "You have unsaved changes",
      expandSection: "Expand section",
      collapseSection: "Collapse section",
      noTranslationsFound: "No translations found matching your search criteria"
    },
    common: {
      cancel: "Cancel",
      save: "Spara",
      delete: "Ta bort",
      edit: "Redigera",
      create: "Skapa",
      close: "Stäng",
      loading: "Laddar...",
      saving: "Sparar...",
      testing: "Testar...",
      success: "Lyckades",
      error: "Error",
      warning: "Warning",
      confirm: "Confirm",
      activate: "Activate",
      deactivate: "Deactivate"
    }
  },

  reports: {
    title: "Player Report System",
    subtitle: "Manage and track player reports with evidence and linked incidents",
    createNewReport: "Skapa ny rapport",
    refresh: "Refresh",
    refreshing: "Refreshing...",
    viewDetails: "View Details",
    linkedReports: "Linked Reports",
    searchPlaceholder: "Search reports by reporter, player, subject, or description...",
    resultsCount: "of",
    resultsText: "reports",
    loadingReports: "Loading reports...",
    noReportsFound: "No player reports found",
    noReportsFoundDescription: "Create a new report to get started",
    noSearchResults: "No reports match your search criteria",
    noSearchResultsDescription: "Try adjusting your search terms",
    attachments: "attachment",
    attachmentsPlural: "attachments",
    linkedReport: "linked report",
    linkedReportsPlural: "länkade rapporter",
    violation: "regelbrott",
    violationsPlural: "regelbrott",
    alreadyAdded: "Redan tillagd",
    selectedViolations: "Valda regelbrott",
    updateSuccess: "Rapport uppdaterad framgångsrikt",
    updateError: "Misslyckades att uppdatera rapport",
    deleteConfirm: "Är du säker på att du vill ta bort rapport",
    deleteSuccess: "Rapport borttagen framgångsrikt",
    deleteError: "Misslyckades att ta bort rapport",
    createSuccess: "Rapport skapad framgångsrikt",
    createError: "Misslyckades att skapa rapport",
    genericError: "Vänligen försök igen",
    unknownError: "Okänt fel",
    logReportUpdated: "Rapport uppdaterad",
    logReportDeleted: "Rapport borttagen",
    logReportCreated: "Rapport skapad",
    logUpdatedReport: "Uppdaterade rapport",
    logDeletedReport: "Tog bort rapport",
    logCreatedNewReport: "Skapade ny rapport",
    violations: {
      title: "Regelbrott",
      selectViolations: "Välj regelbrott",
      selectedViolations: "Valda regelbrott",
      addViolations: "Lägg till regelbrott",
      subtitle: "Klicka på regelbrott för att välja dem för denna rapport",
      types: {
        valueOfLife: "Livets värde",
        powergaming: "Powergaming",
        metagaming: "Metagaming",
        combatlogging: "Combat Logging",
        copbait: "Cop Baiting",
        vdm: "VDM (Vehicle Death Match)",
        rdm: "RDM (Random Death Match)",
        forceperm: "Force Perm",
        newLifeRule: "New Life Rule",
        greenzone: "Green Zone"
      }
    },
    // Form labels  
    reporterLabel: "Rapportör",
    playerLabel: "Spelare",
    discordIdLabel: "Discord-ID",
    priorityLabel: "Prioritet",
    statusLabel: "Status",
    createdAtLabel: "Skapad",
    descriptionLabel: "Beskrivning",
    // Form actions
    linkReportsSubtitle: "Klicka på rapporter för att välja dem, klicka sedan på \"Lägg till\" för att länka dem till denna incident",
    searchReportsPlaceholder: "Sök rapporter efter ämne, spelare eller rapportör...",
    noReportsToLink: "Inga rapporter tillgängliga att länka",
    noReportsMatchSearch: "No reports match your search",
    add: "Add",
    selectedReports: "Selected Reports",
    addReports: "Add {count} Report{plural}",
    cancel: "Cancel",
    report: "Report",
    reports: "Reports",
    // Create/Edit form fields
    subjectLabel: "Subject",
    subjectPlaceholder: "Brief description of the issue",
    descriptionPlaceholder: "Provide detailed information about the incident, including when it happened, what occurred, and any other relevant details...",
    currentUserNote: "You are creating this report as the current logged-in user",
    playerNamePlaceholder: "Enter player name",
    discordIdPlaceholder: "123456789012345678",
    priorityLevels: {
      low: "Low Priority",
      medium: "Medium Priority", 
      high: "High Priority",
      critical: "Critical Priority"
    },
    evidenceAttachments: "Evidence Attachments",
    dragDropFiles: "Drag and drop files here, or click to browse",
    supportedFiles: "Supported: Images (PNG, JPG, GIF, WEBP), Text files (txt), Documents (PDF, DOCX, ODT)",
    attachedFiles: "Attached Files",
    removeAttachment: "Ta bort",
    reportStatus: "Report Status",
    keepOpenDefault: "Keep Open (Default)",
    closeImmediately: "Close Immediately",
    openStatusDescription: "The report will remain open for further investigation and follow-up.",
    closedStatusDescription: "The report will be marked as closed immediately after creation.",
    submitReport: "Submit Report"
  },

  carVariationsEditor: {
    title: "Car Variations Editor",
    subtitle: "Edit vehicle color variations and liveries",
    selected: "Vald",
    basicInformation: "Basic Information",
    modelName: "Model Name",
    lightSettings: "Light Settings",
    sirenSettings: "Siren Settings",
    modelNamePlaceholder: "e.g., nddexplorer",
    newVehicle: "New Vehicle",
    defaultModkit: "0_default_modkit",
    colorNames: {
      primary: "Primary",
      secondary: "Secondary",
      pearl: "Pearl",
      wheel: "Wheel",
    }
  },

  dualFtpManager: {
    title: "Dual FTP-hanterare",
    subtitle: "Hantera filer mellan dev- och prod-servrar",
    close: "Stäng",
    developmentServer: "Utvecklingsserver",
    productionServer: "Produktionsserver",
    connected: "Ansluten",
    disconnected: "Frånkopplad",
    connecting: "Ansluter...",
    disconnect: "Koppla från",
    selectServer: "Välj FTP-server...",
    connectToServer: "Anslut till FTP-server för att visa filer",
    transferProgress: "Överför",
    transferring: "från",
    to: "till",
    instructions: "Anslut till båda servrarna och dra filer eller mappar mellan panelerna för att överföra handling.meta, fordonsfiler och hela kataloger",
    dropFileHere: "Släpp filer eller mappar här för att överföra",
    overwriteConfirm: "Filen finns redan. Vill du skriva över den?",
    overwriteTitle: "Bekräfta överskrivning",
    overwrite: "Skriv över",
    skip: "Hoppa över",
    folderExists: "Mappen finns redan. Vill du slå ihop eller skriva över?",
    folderExistsTitle: "Mappen finns redan",
    merge: "Slå ihop",
    overwriteFolder: "Skriv över",
    copyingFolder: "Kopierar mapp",
    copyingFile: "Kopierar fil",
    folderCopied: "Mapp kopierad framgångsrikt",
    fileCopied: "Fil kopierad framgångsrikt",
    copyError: "Fel vid kopiering",
    searchPlaceholder: "Sök alla kataloger i",
    searchAllDirectories: "Sök alla kataloger",
    loadingDirectory: "Laddar katalog...",
    cancel: "Avbryt",
    failedToOpenFile: "Misslyckades att öppna fil",
    failedToSaveFile: "Misslyckades att spara fil",
    unknownError: "Okänt fel",
    navigationCancelled: "Navigation avbruten",
    navigationFailed: "Navigation misslyckades",
    transferError: "Överföringsfel",
    ftpServerManager: "FTP-serverhanterare",
    devServer: "Dev-server",
    prodServer: "Prod-server",
    contextMenu: {
      openInEditor: "Öppna i",
      editor: "Redigerare",
      copyPath: "Kopiera sökväg",
      copyFilename: "Kopiera filnamn",
      size: "Size",
      path: "Path",
    },
  },

  fileExplorer: {
    createNewFolder: "Skapa ny mapp",
    uploadFile: "Ladda upp fil",
    downloadFile: "Ladda ner fil",
    delete: "Ta bort",
    readyToUpload: "Redo att ladda upp:",
    upload: "Ladda upp",
    cancel: "Avbryt",
    loadingFiles: "Laddar filer...",
    noFilesFound: "Inga filer hittades",
    folderEmpty: "Denna mapp är tom",
    unknownDate: "Okänt datum",
    deleteConfirm: "Är du säker på att du vill ta bort",
    deleteError: "Fel vid borttagning:",
    unknownDeleteError: "Okänt fel vid borttagning",
    loadDirectoryError: "Okänt fel vid laddning av katalog",
    uploadFileError: "Fel vid uppladdning av fil",
    unknownUploadError: "Okänt fel vid uppladdning",
    downloadError: "Okänt fel vid nedladdning",
    createFolderError: "Okänt fel vid skapande av mapp",
  },

  ftpConnectionManager: {
    title: "FTP/SFTP-anslutningar",
    addServer: "Lägg till server",
    connectedTo: "Ansluten till",
    disconnect: "Koppla från",
    timeoutWarning: "Timeout-varning",
    noServersConfigured: "Inga FTP-servrar konfigurerade",
    lastConnected: "Senast:",
    editServer: "Redigera server",
    deleteServer: "Ta bort server",
    connected: "Ansluten",
    connect: "Anslut",
    connecting: "Ansluter...",
    connectionFailed: "Anslutning misslyckades",
    connectionFailedAlert: "Anslutning misslyckades:",
    serverName: "Servernamn",
    serverType: "Servertyp",
    developmentServer: "Utvecklingsserver",
    productionServer: "Produktionsserver",
    host: "Värd",
    port: "Port",
    username: "Användarnamn",
    password: "Lösenord",
    protocol: "Protokoll",
    passiveMode: "Passivt läge",
    useSSLTLS: "Använd SSL/TLS",
    rememberPassword: "Kom ihåg lösenord",
    remotePath: "Fjärrsökväg",
    testConnection: "Testa anslutning",
    save: "Spara",
    cancel: "Avbryt",
    update: "Uppdatera",
    add: "Lägg till",
    editServerTitle: "Redigera server",
    addNewServerTitle: "Lägg till ny server",
    noConnectionSelected: "Ingen FTP-anslutning vald",
    selectOrCreateConnection: "Välj eller skapa en FTP-anslutning för att utforska filer",
    connectionFailedStatus: "Anslutning misslyckades",
  },

  fxManifestEditor: {
    title: "FX Manifest-redigerare",
    visualEditor: "Visuell redigerare",
    codeEditor: "Kodredigerare",
    reset: "Återställ",
    save: "Spara",
    close: "Stäng",
    basicInformation: "Grundläggande information",
    fxVersion: "FX-version",
    game: "Spel",
    author: "Författare",
    version: "Version",
    description: "Beskrivning",
    authorPlaceholder: "Ditt namn",
    versionPlaceholder: "1.0.0",
    descriptionPlaceholder: "Resursbeskrivning...",
    files: "Filer",
    addFile: "Lägg till fil",
    dataFiles: "Datafiler",
    addDataFile: "Lägg till datafil",
    clientScripts: "Klientskript",
    addClientScript: "Lägg till klientskript",
    serverScripts: "Serverskript",
    addServerScript: "Lägg till serverskript",
    sharedScripts: "Delade skript",
    addSharedScript: "Lägg till delat skript",
    dependencies: "Beroenden",
    addDependency: "Lägg till beroende",
    exports: "Exporter",
    addExport: "Lägg till export",
    serverExports: "Serverexporter",
    addServerExport: "Lägg till serverexport",
    exportName: "Exportnamn",
    exportDescription: "Exportbeskrivning",
    type: "Typ",
    file: "Fil",
    preview: "Förhandsvisning",
    codeEditorPlaceholder: "-- FxManifest.lua content...",
  },

  handlingEditor: {
    title: "Fordonshanteringsredigerare",
    subtitle: "Konfigurera fordonsphysik och prestanda",
    close: "Stäng",
    save: "Spara",
    reset: "Återställ",
    import: "Importera",
    export: "Exportera",
    tabs: {
      aero: "Aerodynamik",
      chassis: "Chassi", 
      engine: "Motor",
      transmission: "Växellåda",
      brakes: "Bromsar",
      suspension: "Fjädring",
      traction: "Traktion",
      damage: "Skada",
      misc: "Övrigt",
      raw: "Rådata"
    },
    sections: {
      basic: "Grundläggande egenskaper",
      advanced: "Avancerade inställningar",
      physics: "Fysikegenskaper"
    },
    properties: {
      handlingName: "Hanteringsnamn",
      mass: "Massa (kg)",
      dragCoeff: "Luftmotståndskoefficient",
      downforce: "Nedkraftsmodifierare",
      windResistance: "Vindmotstånd",
      downforceModifier: "Nedkraftsmodifierare",
      driveForce: "Drivkraft",
      driveInertia: "Drivtröghet",
      maxFlatVel: "Max platt hastighet",
      driveGears: "Drivväxlar",
      brakeForce: "Bromskraft",
      brakeBiasFront: "Bromsfördelning fram",
      handBrakeForce: "Handbroms kraft",
      steeringLock: "Styrlås",
      tractionCurveMax: "Traktionskurva max",
      tractionCurveMin: "Traktionskurva min",
      tractionCurveLateral: "Traktionskurva lateral",
      tractionSpringDeltaMax: "Traktionsfjäder delta max",
      lowSpeedTractionLossMult: "Låghastighets traktionsförlust mult",
      camberStiffness: "Camber styvhet",
      tractionBiasFront: "Traktionsfördelning fram",
      tractionLossMult: "Traktionsförlust mult",
      suspensionForce: "Fjädringskraft",
      suspensionCompDamp: "Fjädring kompressionsdämpning",
      suspensionReboundDamp: "Fjädring returdämpning",
      suspensionUpperLimit: "Fjädring övre gräns",
      suspensionLowerLimit: "Fjädring nedre gräns",
      suspensionRaise: "Fjädringshöjning",
      suspensionBiasFront: "Fjädringsfördelning fram",
      antiRollBarForce: "Anti-rollstångskraft",
      antiRollBarBiasFront: "Anti-rollstång fördelning fram",
      rollCentreHeightFront: "Rullcenterhöjd fram",
      rollCentreHeightRear: "Rullcenterhöjd bak",
      shiftTimeUp: "Växlingstid upp",
      powerBias: "Kraftfördelning",
      tireGripMax: "Däckgrepp max",
      tireGripMin: "Däckgrepp min",
      springStrength: "Fjäderstyrka",
      compressionDamping: "Kompressionsdämpning",
      reboundDamping: "Returdämpning"
    },
    descriptions: {
      aero: "Denna uppsättning värden representerar fordonets kroppsform och påverkar mest topphastighetsbeteende.",
      chassis: "Denna uppsättning värden representerar fordonets kropp och spelar en stor roll för hur fordonet beter sig överlag.",
      engine: "Fordonets rörelsekraft, denna uppsättning värden styr detaljer om hur olika delar av motorn beter sig. Fungerar i nära relation med växellådan.",
      transmission: "Hur motorn överför kraft till hjulen.",
      brakes: "Fordonets bromskraft och bromsfördelning.",
      traction: "Hur fordonets däck grepper vägbanan.",
      downforceModifier: "Nedkraft är ett sätt att få grepp vid hastighet och kan ökas av spoilers. I V representeras nedkraft som två beteenden - en faktisk nedkraft som trycker ner bilen och en separat greppökning baserad på fDownforceModifier och en regeluppsättning.",
      windResistance: "Fordonets kropps luftmotstånd. Högre motstånd innebär en tidigare upplevd kraftförlust vid högre hastighet, vilket resulterar i en lägre toppfart. Som en multiplikator definierar detta värde hur mycket luftdrag kommer att skalas med hastighet.",
      mass: "Mätt i kg, massa är endast ansvarig för interaktionen mellan entiteter. Massa är inte alls relaterad till fysisk smidighet och påverkar inte bilens fysik alls. Påverkar endast hur väl bilen klarar sig vid kollision med andra entiteter.",
      power: "Även kallad motoreffekt, den dikterar målaccelerationen som motorn siktar på, mätt i G-krafter. Hjulgreppet kanske inte kan hantera det dock. Växling modulerar detta värde i förhållanden för att översätta det till vridmoment.",
      driveInertia: "Hur responsiv motorvarvtalet kommer att vara för gasreglage. Högre värden resulterar i snabbare RPM-acceleration och deceleration, medan lägre värden resulterar i mer trögt RPM.",
      topSpeed: "Maximal motors toppfart. Över denna hastighet kommer motoreffekten att försämras kraftigt. Kom ihåg att växling kommer att sträcka sig över denna 'längd'.",
      numberOfGears: "Antal växlar som standard. Eftersom växlar modulerar fInitialDriveForce upp till fInitialDriveMaxFlatVel, rekommenderas att behålla ett rimligt antal växlar för din toppfart. Kom ihåg att växellådsuppgraderingar lägger till en växel totalt.",
      powerBias: "Definierar hur kraften från fInitialDriveForce fördelas mellan axlarna. 0.0 innebär en helt RWD-inställning, som endast levererar kraft till bakhjulen.",
      brakeStrength: "Hur många G av deceleration som appliceras på varje hjul. fTractionCurveMax och fBrakeForce är nära relaterade. Med perfekt balans räcker en fjärdedel broms för att få varje hjul att låsa.",
      brakeBias: "Fördelning av bromsstyrkan mellan axlarna. Vanligtvis är den bästa balansen mellan 0.55 och 0.7 för bästa bromskapacitet, eftersom den räknar in viktöverföringen som följer vid bromsning.",
      handbrakeStrength: "Liknande fBrakeForce, men appliceras endast på bakaxel(n).",
      tireGripMax: "Maximala G som fordonets hjul kan dra. I V representeras grepp som hur mycket fordonets däck kan accelerera eller decelera bilens kropp som helhet.",
      tireGripMin: "Minimala G som fordonets hjul kan dra. Dessa värden ändras konstant av sammanhang, som fjädringstryck, yta som däcket kör på, etc.",
      tractionCurveLateral: "Glidvinkel vid vilken bilen kommer att njuta av bästa tillgängliga grepp. Fordonet tenderar att hålla sig under hälften av detta värde. Det rekommenderas att behålla det på standard 22.5 på de flesta fordon.",
      suspension: "Styvare, mjukare, lös, sträng. Denna sektion styr hur din bil flyter ovanför sina hjul.",
      springStrength: "Fjäderstyrka.",
      compressionDamping: "Hur starkt fjäderstyrkan dämpas vid komprimering.",
      reboundDamping: "Hur starkt fjäderstyrkan dämpas vid dekomprimering.",
      raw: "Redigera inte värdena här. Detta område tjänar endast som en förhandsgranskning av filen."
    },
    labels: {
      rawData: "Rådata"
    },
    tooltips: {
      mass: "Fordonsvikt påverkar acceleration och hantering",
      dragCoeff: "Luftmotståndskoefficient (högre = mer motstånd)",
      downforce: "Nedåtriktad kraft vid höga hastigheter för grepp",
      driveForce: "Motorns kraftleverans till hjulen",
      brakeForce: "Maximal bromskraft",
      steeringLock: "Maximal styrvinkel i grader"
    },
    presets: {
      title: "Fordonsförinställningar",
      sports: "Sportbil",
      muscle: "Muscle Car",
      suv: "SUV",
      truck: "Lastbil",
      motorcycle: "Motorcykel",
      apply: "Tillämpa förinställning"
    },
    messages: {
      saved: "Hanteringskonfiguration sparad framgångsrikt",
      loaded: "Hanteringskonfiguration laddad",
      resetConfirm: "Är du säker på att du vill återställa alla värden?",
      invalidData: "Ogiltig hanteringsdata upptäckt",
      exportSuccess: "Hanteringsdata exporterad framgångsrikt"
    }
  },

  // FiveM Vehicle Handler
  fiveMVehicleHandler: {
    blueLight: "Blått ljus",
    redLight: "Rött ljus", 
    whiteLight: "Vitt ljus",
    blackLight: "Svart ljus",
    customColor: "Anpassad färg",
    sirenIndex: "Siren",
    setToColor: "inställd på {color}",
    colorAppliedTo: "{color} tillämpat på {count} sirener",
    newSirenAdded: "Ny siren tillagd (Totalt: {count})",
    sirenRemoved: "Siren {index} borttagen",
    sirenSettings: "Sireninställningar",
    fileStructureAnalysis: "Filstrukturanalys",
    foundSirenConfigurations: "Hittade {count} sirenkonfigurationer",
    clickToApplyColorAll: "Klicka för att tillämpa färg på alla sirener:",
    redBlueAlternate: "Röd/Blå växelvis",
    sirenConfigurations: "Sirenkonfigurationer",
    addNewSiren: "Lägg till ny siren",
    removeSiren: "Ta bort siren",
    noSirensFound: "Inga sirener hittades i denna fil",
    
    // Missing translations for CarcolsEditor
    orangeLight: "Orange ljus",
    orangeEmergencyLight: "Orange ljus - Bärgning/underhåll",
    carcolsEditor: "Carcols-redigerare",
    close: "Stäng",
    quickColorSettings: "Snabba färginställningar",
    blueOnly: "Endast blått",
    redOnly: "Endast rött",
    orangeOnly: "Endast orange",
    redBlueMix: "Rött + Blått",
    individualConfiguration: "Konfiguration för blåljus på fordon - kan ändras individuellt",
    colorLabel: "Färg",
    blueShort: "Blå",
    redShort: "Röd",
    orangeShort: "Orange",
    intensity: "Intensitet",
    coronaSize: "Corona-storlek",
    coronaIntensity: "Corona-intensitet",
    flash: "Blink",
    light: "Ljus",
    spotlight: "Spotlight",
    rotate: "Rotera",
    tipsTitle: "Tips",
    tipsText: "Intensitet kontrollerar ljusstyrka (0.0-10.0), Corona-storlek kontrollerar glödeffekt (0.0-2.0), Corona-intensitet kontrollerar glödstyrka (0-100)."
  },

  todoCategories: {
    title: "Todo-kategorier",
    description: "Hantera kategorier för Todo-uppgifter med rollbaserad åtkomst",
    newCategory: "Ny kategori",
    editCategory: "Redigera kategori",
    name: "Namn",
    nameRequired: "Namn *",
    namePlaceholder: "Ange kategorinamn...",
    categoryDescription: "Beskrivning",
    descriptionPlaceholder: "Ange beskrivning (valfritt)...",
    parentCategory: "Föräldrakategori",
    noParentCategory: "Ingen föräldrakategori",
    color: "Färg",
    colorTooltip: "Välj färg",
    visibleToRoles: "Synlig för roller",
    visibleToRolesRequired: "Synlig för roller *",
    inheritanceInfo: "📋 Åtkomstärv: Denna underkategori ärver automatiskt åtkomst från föräldrakategorin. Du kan lägga till extra roller genom att kryssa för fler.",
    createSubcategory: "Skapa underkategori",
    edit: "Redigera",
    delete: "Ta bort",
    cancel: "Avbryt",
    save: "Spara",
    updating: "Uppdaterar...",
    creating: "Skapar...",
    createCategory: "Skapa kategori",
    updateCategory: "Uppdatera kategori",
    deleteConfirmation: "Är du säker på att du vill ta bort kategorin",
    deleteWithChildren: "tillsammans med alla underkategorier",
    deleteWithTodos: "Detta kommer också att ta bort alla associerade todos",
    deleteSuccess: "Kategori borttagen",
    deleteError: "Fel vid borttagning av kategori",
    createSuccess: "Kategori skapad",
    updateSuccess: "Kategori uppdaterad",
    createError: "Fel vid skapande av kategori",
    updateError: "Fel vid uppdatering av kategori",
    loading: "Laddar kategorier...",
    noCategories: "Inga kategorier hittades. Skapa din första kategori för att komma igång.",
    subcategory: "underkategori",
    mainCategory: "Huvudkategori",
    newSubcategory: "Ny underkategori under",
    cannotDeleteHasTodos: "Kan inte ta bort - har",
    deleteCategory: "Ta bort kategorin",
    tasksAttached: "uppgifter kopplade",
    andSubcategories: "och underkategorier",
    subcategoriesWillBeDeleted: "underkategorier som också kommer att tas bort",
    createFirstCategory: "Skapa första kategori",
    tasks: "uppgifter",
    roles: {
      veriagent: "Veriagent",
      moderator: "Moderator",
      developers: "Utvecklare",
      admin: "Admin",
      superAdmin: "Super Admin",
      veriagentDesc: "Grundroll för verifieringsagenter",
      moderatorDesc: "Gemenskapsmoderatorer med utökade behörigheter",
      developersDesc: "Tekniska teammedlemmar och utvecklare",
      adminDesc: "Systemadministratörer med full åtkomst",
      superAdminDesc: "Högsta nivå administratörer med alla behörigheter"
    }
  }
};
